/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ workspace: NonNullable<unknown> }} Invite_X15_JoiningInputs */

const en_invite_x15_joining = /** @type {(inputs: Invite_X15_JoiningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Adding you to ${i?.workspace}.`)
};

/**
* | output |
* | --- |
* | "Adding you to {workspace}." |
*
* @param {Invite_X15_JoiningInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const invite_x15_joining = /** @type {((inputs: Invite_X15_JoiningInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_JoiningInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_invite_x15_joining(inputs)
});